import { Component } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-save-as-calculation',
    templateUrl: './save-as-calculation.component.html',
    styleUrl: './save-as-calculation.component.scss',
    standalone: false
})
export class SaveAsCalculationComponent {
   saveAsCalculationForm: FormGroup;
   submitted = false;
   submitData$ = new Subject<string>();

   constructor(private builder: FormBuilder)
   {
       this.initializeForm();
   }

   /**
   * convenience getter for easy access to form controls
   */
   get controls() {
       return this.saveAsCalculationForm.controls;
   }

   /**
   * create form control and add custom validation
   */
   private initializeForm() {
       this.saveAsCalculationForm = this.builder.group({
           name: new FormControl('', [
               Validators.required,
               Validators.minLength(3)
           ])
       });
   }

   /**
   * save calculation data
   */
   saveAsCalculation() {
       this.submitted = true;
       if (this.saveAsCalculationForm.invalid) {
           return;
       }
       const formValue = this.saveAsCalculationForm.getRawValue();

       this.submitData$.next(formValue.name);
   }
}
